export class AddressValidationUploadModel {
  photoBase64Content: string;
  studentRegistrationSchoolYearId: number;
  photoGuid: string;
  contentType: string;
}
